// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wNr00ABD{padding-right:4px}.uRL3di3d{list-style-type:none;padding:0}.uRL3di3d li{padding:4px 0}.yqFLdjd8{border:1px solid var(--theme-text-emphasis);border-radius:.5em;margin-bottom:1.2em;padding:1.2em}.cSTzthnT{margin-top:0}`, "",{"version":3,"sources":["webpack://./src/page-components/shared/used-in-panels.module.scss"],"names":[],"mappings":"AAAA,UACE,iBAAA,CAGF,UACE,oBAAA,CACA,SAAA,CAEA,aACE,aAAA,CAIJ,UACE,2CAAA,CACA,kBAAA,CACA,mBAAA,CACA,aAAA,CAGF,UACE,YAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconContainer": `wNr00ABD`,
	"list": `uRL3di3d`,
	"panel": `yqFLdjd8`,
	"title": `cSTzthnT`
};
export default ___CSS_LOADER_EXPORT___;
